export const fetchConfig = async () => {
  const resp = await fetch('/config.json');
  return resp.json();
};
